// Re:Vault and Re:Vault OS are two ways into the same thing: this tabbed shell, and a desktop
// (/os/) whose "Re:Vault" app is this shell in a window, opened with ?os=1. In that mode there is
// no first-run welcome (the desktop does not have one of its own yet; see
// docs/ONBOARDING-2026-10.md, follow-ups), the Desktop tile is hidden (we're in it), and
// the desktop can hand us an address ("revault example.com" in its terminal, a web app from its
// store) with a `revault-go` message. Only the document that framed us is heard, and only when it
// really is the desktop on this origin.
import { metric } from "../shared/metric.js";

export const OS_PATH = "/os/";

export const inOS = (() => {
	try {
		return window.parent !== window && new URLSearchParams(location.search).get("os") === "1"
			&& window.parent.location.origin === location.origin && window.parent.location.pathname.startsWith(OS_PATH);
	} catch { return false; }
})();

// Leaving for the desktop replaces this page; main.js's beforeunload asks first if a Linux
// machine is running, so nothing else needs guarding here.
export function openDesktop() {
	if (inOS) return;
	metric("desktop");
	location.assign(OS_PATH);
}

export function initOSHost(go) {
	if (!inOS) return;
	document.documentElement.dataset.inOs = "1";
	window.addEventListener("message", (e) => {
		if (e.source !== window.parent || e.origin !== location.origin) return;
		const d = e.data;
		if (!d || d.type !== "revault-go" || typeof d.url !== "string") return;
		const url = d.url.trim();
		if (!url || url.length > 2048 || [...url].some((c) => c.charCodeAt(0) < 32 || c.charCodeAt(0) === 127)) return; // no control characters
		go(url);
	});
}
